import { addClass, hasClass } from '../../../../core/utils/src/dom';
function calculateAvailableSpace(trigger, scrollableParent, viewport) {
    var left = trigger.right - Math.max(scrollableParent.left, 0);
    var top = trigger.bottom - Math.max(scrollableParent.top, 0);
    var dropdownRelativeTop = trigger.bottom - scrollableParent.top;
    var bottom = scrollableParent.height - dropdownRelativeTop - Math.max(scrollableParent.bottom - viewport.height, 0);
    var dropdownRelativeLeft = trigger.left - scrollableParent.left;
    var right = scrollableParent.width - dropdownRelativeLeft - Math.max(scrollableParent.right - viewport.width, 0);
    return { left: left, top: top, right: right, bottom: bottom };
}
function getOverflowParent(element) {
    var parent = element.parentElement;
    while (parent && getComputedStyle(parent).overflow === 'visible') {
        parent = parent.parentElement;
    }
    return parent || document.body;
}
var DropdownFitHandler = /** @class */ (function () {
    function DropdownFitHandler(dropdown, button) {
        this.dropdown = dropdown;
        this.button = button;
        this.DROP_CLASSES = {
            maxHeight: 'awsui-button-dropdown-drop-up',
            maxWidth: 'awsui-button-dropdown-drop-left'
        };
    }
    DropdownFitHandler.prototype.dropOppositeDirection = function (prop) {
        addClass(this.dropdown, this.DROP_CLASSES[prop]);
    };
    DropdownFitHandler.prototype.isDroppedOppositeDirection = function (prop) {
        return hasClass(this.dropdown, this.DROP_CLASSES[prop]);
    };
    DropdownFitHandler.prototype.setMax = function (prop, value) {
        if (!this.dropdown) {
            return;
        }
        if (!value) {
            this.dropdown.style[prop] = null;
            return;
        }
        this.dropdown.style[prop] = value + "px";
    };
    DropdownFitHandler.prototype.initializeFitting = function (props) {
        var _this = this;
        props.forEach(function (prop) {
            if (!_this.isDroppedOppositeDirection(prop)) {
                _this.setMax(prop, null);
            }
        });
    };
    DropdownFitHandler.prototype.fitProperty = function (prop, currentValue, defaultDirection, otherDirection) {
        if (defaultDirection > currentValue) {
            return;
            // If dropping it to the other direction solves it, go ahead
        }
        else if (otherDirection > currentValue) {
            this.dropOppositeDirection(prop);
            // There is not enough space, find the best direction and set max
        }
        else if (defaultDirection > otherDirection) {
            this.setMax(prop, defaultDirection);
        }
        else {
            this.setMax(prop, otherDirection);
            this.dropOppositeDirection(prop);
        }
    };
    DropdownFitHandler.prototype.getAvailableSpace = function () {
        var trigger = this.button.getBoundingClientRect();
        var scrollableParent = getOverflowParent(this.dropdown).getBoundingClientRect();
        var viewport = { width: window.innerWidth, height: window.innerHeight };
        var _a = calculateAvailableSpace(trigger, scrollableParent, viewport), top = _a.top, bottom = _a.bottom, right = _a.right, left = _a.left;
        // We want to leave some empty space before we reach the window
        var PADDING = 50;
        return {
            availableTop: top - trigger.height - PADDING,
            availableBottom: bottom - PADDING,
            // dropdown should not be smaller than the button
            availableRight: Math.max(right - PADDING, trigger.width),
            availableLeft: Math.max(left - PADDING, trigger.width)
        };
    };
    DropdownFitHandler.prototype.scrollToHighlightedOption = function () {
        if (!this.dropdown) {
            return;
        }
        var highlightedOption = this.dropdown.querySelector('.awsui-button-dropdown-item-highlighted');
        if (!highlightedOption) {
            return;
        }
        this.dropdown.scrollTop = highlightedOption.offsetTop;
    };
    DropdownFitHandler.prototype.fitDropdown = function () {
        // Remove size adjustments and measure dropdown without scrollbars, add min width
        this.initializeFitting(['maxWidth', 'maxHeight']);
        var _a = this.getAvailableSpace(), availableTop = _a.availableTop, availableBottom = _a.availableBottom, availableRight = _a.availableRight, availableLeft = _a.availableLeft;
        // Open below or above or set max height
        this.fitProperty('maxHeight', this.dropdown.offsetHeight, availableBottom, availableTop);
        // Open to left or right or set max width
        this.fitProperty('maxWidth', this.dropdown.offsetWidth, availableRight, availableLeft);
        // Preserve dropdown's normal width
        var dropdownNormalWidth = this.dropdown.getBoundingClientRect().width;
        this.dropdown.style.width = dropdownNormalWidth + "px";
        // Once we determined normal dropdown width, we can enable text wrapping
        addClass(this.dropdown, 'awsui-button-dropdown-wrapped');
        this.scrollToHighlightedOption();
    };
    return DropdownFitHandler;
}());
export default DropdownFitHandler;
//# sourceMappingURL=dropdown-fit-handler.js.map